import { useDispatch } from 'react-redux';
import { clearUserData, setUserData, UserData } from '@/store/slices/UserDataSlice';
import { useEffect } from 'react';

export default function UserStoreState(props: UserData) {

  // save the user data in the redux store using dispatch whenever the props changes
  const dispatch = useDispatch();

  useEffect(() => {

    // get the data you want to save
    const data = props.userData;
    dispatch(setUserData(data));

    return () => {
      dispatch(clearUserData());
    }
  }, [props.userData]);

  return null;
}